import React, { Component } from 'react';
import MTD from "./MTD";
import YTD from "./YTD";
import Seasonal from "./Seasonal";
import Disclaimer from "./Disclaimer";
import "./index.scss";

class index extends Component {
    render() {
        return (
            <div className="performanceReview">
                <MTD />
                <YTD />
                <Seasonal />
                <Disclaimer />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/index.js